import { useEffect } from 'react';
import {
  useStoreActions,
  useStoreRehydrated,
  useStoreState,
} from '@discover-data/stores/restaurant/hooks';
import useSortQueryState from './useQueryState';

/**
 * Sync the router state value to the restaurant store
 */
export default function useSyncSort() {
  const rehydrated = useStoreRehydrated();
  const storeValue = useStoreState((state) => state.sort.value);
  const setStoreValue = useStoreActions((actions) => actions.sort.set);
  const [routerValue] = useSortQueryState();

  useEffect(() => {
    if (!rehydrated) {
      return;
    }

    // only set if the value changed
    if (routerValue !== storeValue) {
      setStoreValue(routerValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rehydrated, routerValue]); // we only care about changes to the router value
}
